import React from 'react';
import { Link } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';
import { useToast } from '../../components/Toast';
import { gettingStartedFaq } from '../../data/support/gettingStartedFaq';
import { SupportFaqList, SupportGuideLayout, SupportHelpFooter, SupportLinkList, openChannelTalk } from './SupportGuide';

export const FIRST_TRY_ITEMS = [
  { to: '/create-saenggibu', title: '생기부 써보기', body: '메모 몇 줄이면 세특 문장이 나와요' },
  { to: '/chat?category=ppt_maker', title: '수업 PPT 만들기', body: '주제만 적으면 슬라이드가 나와요' },
  { to: '/chat?category=worksheet_gen', title: '학습지 만들기', body: '문제와 정답을 같이 만들어요' },
  { to: '/chat?category=image_generation', title: '수업 이미지 만들기', body: '설명 한 줄로 그림을 그려요' },
];

const GettingStartedPage = () => {
  const { showToast } = useToast();

  return (
    <>
      <Helmet>
        <title>왓퀴즈 시작 가이드 | 교사 전용 AI</title>
        <meta name="description" content="교사 인증 후 최신 AI로 학습지를 만드는 방법을 안내해요." />
        <meta name="keywords" content="왓퀴즈 시작하기, 교사 AI 가이드, 교사 인증 방법, AI 플랫폼 사용법, 교사 전용 AI 튜토리얼, AI 학습지" />
        <meta property="og:title" content="왓퀴즈 시작 가이드 | 교사 전용 AI" />
        <meta property="og:description" content="교사 인증 후 최신 AI로 학습지를 만드는 방법을 안내해요." />
        <meta property="og:type" content="website" />
        <link rel="canonical" href="https://whatquiz.co.kr/support/getting-started" />
      </Helmet>

      <SupportGuideLayout current="처음 시작하기">
        <section className="sg__hero">
          <h1>처음이라면 여기서 시작해요</h1>
          <p>가입하면 바로 무료로 써볼 수 있어요</p>
          <Link to="/create-saenggibu" className="sg__cta">무료로 생기부 써보기</Link>
        </section>

        <section className="sg__card">
          <h2>이런 걸 바로 할 수 있어요</h2>
          <SupportLinkList items={FIRST_TRY_ITEMS} />
        </section>

        <section className="sg__card">
          <h2>자주 묻는 질문</h2>
          <SupportFaqList faqs={gettingStartedFaq} />
        </section>

        <SupportHelpFooter onChat={() => openChannelTalk(showToast)} />
      </SupportGuideLayout>
    </>
  );
};

export default GettingStartedPage;
